import { useEffect, useState } from "react";

export type BuscarItem = {
  servico_id: number;

  tipo_servico: {
    id: number | null;
    nome: string | null;
    tipo_precificacao: "diaria" | "creche" | "horaria" | string | null;
  };

  anfitriao: {
    id: number | null;
    nome: string | null;
    bio?: string | null;
    endereco?: string | null;
    cidade?: string | null;
  };

  imagens: string[];

  vagas: {
    limite_pets: number;
    vagas_disponiveis: number;
    label: string;
  };

  avaliacoes: {
    media: number;
    total: number;
    texto: string | null;
    historico?: Array<{
      id: number;
      nota: number;
      comentario: string;
      tem_comentario?: boolean;
      tutor_nome: string;
      servico_nome?: string | null;
      data?: string | null;
    }>;
  };

  preferencias?: {
    aceita: string[];
    porte: string[];
    adicionais: string[];
  };

  cancelamento?: {
    tag: string;
    badge: string;
    resumo_curto: string | null;
    detalhe: string | null;
  };

  preco_base: number;
  tempo_resposta?: string | null;
};

export function useBuscar(queryString: string) {
  const [items, setItems] = useState<BuscarItem[]>([]);
  const [total, setTotal] = useState<number>(0);
  const [err, setErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    setErr(null);

    fetch(`/api/buscar-servicos?${queryString}`, { headers: { Accept: "application/json" } })
      .then(async (r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json();
      })
      .then((json) => {
        const resultados = json.resultados ?? json.items ?? [];
        const count = json.count ?? json.total ?? resultados.length;

        setItems(resultados);
        setTotal(Number(count || 0));
      })
      .catch((e) => setErr(e?.message || String(e)))
      .finally(() => setLoading(false));
  }, [queryString]);

  return { items, total, err, loading };
}
